// src/components/common/NotificationsDropdown.tsx
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NotificationBadge, NotificationList } from '@/components/common';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui";
import { useNotifications } from '@/hooks/useNotifications';
import { logError } from '@/utils/logger';

export default function NotificationsDropdown() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { notifications, isLoading, error, markAllAsRead } = useNotifications();

    const handleViewAll = () => {
        markAllAsRead();
        navigate('/notifications');
    };

    if (error) {
        logError('Error loading notifications', error);
    }

    return (
        <DropdownMenu>
            <NotificationBadge count={notifications.length} />
            <DropdownMenuContent className="w-80" align="end">
                <DropdownMenuLabel>{t("header.notifications")}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <NotificationList
                    notifications={notifications}
                    onViewAll={handleViewAll}
                    isLoading={isLoading}
                />
            </DropdownMenuContent>
        </DropdownMenu>
    );
} 